import React, { useState, useEffect, useCallback } from 'react';



import api from '../services/api';



import { INDIAN_STATES, COUNTRIES, MAJOR_CITIES } from '../config/geoData';



import Modal from '../components/common/Modal';



import { useDebounce } from '../hooks/useDebounce';



import Pagination from '../components/common/Pagination';



import BulkUpload from '../components/common/BulkUpload';



import { useAuth } from '../context/AuthContext';



import { getAvatarColors } from '../utils/avatars';



import { DOC_TYPE_LABELS, docTypeLabel } from '../utils/documentUtils';

import { SkeletonTable } from '../components/common/Skeleton';

import ExportButton from '../components/common/ExportButton';







const CLIENT_TYPES = ['generic_pharma', 'innovator_pharma', 'cro', 'biotech', 'research_institution', 'api_manufacturer', 'other'];



const typeColors = { generic_pharma: 'primary', innovator_pharma: 'info', cro: 'success', biotech: 'warning', research_institution: 'neutral', api_manufacturer: 'purple', other: 'neutral' };



const typeLbl = t => t.split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');







const ID_TYPES = ['GSTN', 'TIN', 'GST/HST', 'OTHERS'];



const PREDEFINED_ID_TYPES = ['GSTN', 'TIN', 'GST/HST'];







const defaultForm = {



  name: '', trading_name: '', type: 'generic_pharma', email: '', phone: '', contact_person: '',



  company_id_type: '', company_id_value: '', website: '',



  address: '', city: '', state: '', zip_code: '', country: 'India',



  billing_same_as_primary: true, billing_address: '', billing_city: '', billing_state: '', billing_zip_code: '', billing_country: '',



  shipping_same_as_primary: true, shipping_address: '', shipping_city: '', shipping_state: '', shipping_zip_code: '', shipping_country: '',



  assigned_to: '', notes: '', is_partner: false,



  license_number: '', license_expiry_date: '', credit_limit: '',



};







function LeadScoreBadge({ score, grade }) {



  const colors = {



    A: { bg: '#dcfce7', text: '#15803d', border: '#86efac' },



    B: { bg: '#dbeafe', text: '#1d4ed8', border: '#93c5fd' },



    C: { bg: '#fef3c7', text: '#92400e', border: '#fcd34d' },



    D: { bg: '#fed7aa', text: '#c2410c', border: '#fdba74' },



    F: { bg: '#fee2e2', text: '#dc2626', border: '#fca5a5' },



  };



  const c = colors[grade] || colors.F;



  return (



    <span title={`Lead score: ${score}/100`} style={{



      display: 'inline-flex', alignItems: 'center', gap: 3,



      padding: '1px 7px', borderRadius: 10, fontSize: '0.7rem', fontWeight: 700,



      background: c.bg, color: c.text, border: `1px solid ${c.border}`,



    }}>



      {grade} · {score}



    </span>



  );



}







export default function Clients() {



  const { isAdmin, isManager, user } = useAuth();



  const canWrite = true; // Enable for all authenticated users



  const [data, setData] = useState({ data: [], total: 0, page: 1, limit: 15 });



  const [loading, setLoading] = useState(true);



  const [scores, setScores] = useState({});



  const [viewScore, setViewScore] = useState(null);



  const [search, setSearch] = useState('');



  const [typeFilter, setTypeFilter] = useState('');

  const [approvalFilter, setApprovalFilter] = useState('');



  const [page, setPage] = useState(1);



  const [modal, setModal] = useState({ open: false, mode: 'add', item: null });



  const [viewModal, setViewModal] = useState({ open: false, client: null, contacts: [], inquiries: [] });



  const [form, setForm] = useState(defaultForm);



  const [users, setUsers] = useState([]);



  const [saving, setSaving] = useState(false);



  const [deleteConfirm, setDeleteConfirm] = useState(null);



  const [error, setError] = useState('');



  const [dupWarning, setDupWarning] = useState({ open: false, matches: [] });



  const [bulkOpen, setBulkOpen] = useState(false);



  const [companyIdSel, setCompanyIdSel] = useState('');



  const [createDocForm, setCreateDocForm] = useState({ doc_type: 'nda', doc_description: '', file: null });



  const [docs, setDocs] = useState([]);



  const [docForm, setDocForm] = useState({ doc_type: 'nda', doc_description: '', file: null });



  const [docUploading, setDocUploading] = useState(false);



  const [docError, setDocError] = useState('');



  const [clientPerms, setClientPerms] = useState([]);

  const [permForm, setPermForm] = useState({ user_id: '', access_level: 'read_only', notes: '' });

  const [permSaving, setPermSaving] = useState(false);

  const [permError, setPermError] = useState('');



  const [gstinStatus, setGstinStatus] = useState({ checked: false, valid: null, state_name: '', state_code: '', pan: '', error_message: '' });



  const [gstinValidating, setGstinValidating] = useState(false);



  const [portalLink, setPortalLink] = useState('');



  const [portalLinkClientId, setPortalLinkClientId] = useState(null);



  const [emailState, setEmailState] = useState({ open: false, templates: [], selectedId: '', to_email: '', to_name: '', sending: false, sent: false, error: '' });



  const [extraAddresses, setExtraAddresses] = useState([]);



  const [addrForm, setAddrForm] = useState({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' });



  const [addrEditId, setAddrEditId] = useState(null);



  const [addrFormOpen, setAddrFormOpen] = useState(false);



  const [addrSaving, setAddrSaving] = useState(false);



  const [addrModal, setAddrModal] = useState({ open: false, entityId: null, entityName: '' });







  const validateGstin = async (value) => {



    const gstin = (value || '').trim().toUpperCase();



    if (!gstin) { setGstinStatus({ checked: false, valid: null, state_name: '', state_code: '', pan: '', error_message: '' }); return; }



    setGstinValidating(true);



    try {



      const { data } = await api.get('/clients/validate-gstin', { params: { gstin } });



      setGstinStatus({ checked: true, valid: data.valid, state_name: data.state_name || '', state_code: data.state_code || '', pan: data.pan || '', error_message: data.error_message || '' });



      if (data.valid && data.state_name) {



        setForm(p => ({ ...p, state: data.state_name }));



      }



    } catch {



      setGstinStatus({ checked: true, valid: false, state_name: '', state_code: '', pan: '', error_message: 'Validation failed. Please try again.' });



    } finally { setGstinValidating(false); }



  };







  const debouncedSearch = useDebounce(search, 300);



  const load = useCallback(async () => {



    setLoading(true);



    try {



      const params = {

        page,

        limit: 15,

        search: debouncedSearch || undefined,

        type: typeFilter || undefined,

        approval_status: approvalFilter || undefined,

      };

      // Role-based filtering is now enforced on the backend



      const { data: res } = await api.get('/clients', { params });



      setData({ ...res, data: (res.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || '')) });



    } finally { setLoading(false); }



  }, [page, debouncedSearch, typeFilter, approvalFilter, isAdmin, user?.id]);







  useEffect(() => { load(); }, [load]);



  useEffect(() => { if (canWrite) api.get('/users').then(r => setUsers(r.data.data || [])).catch(() => { }); }, [canWrite]);



  useEffect(() => {



    if (canWrite) {



      api.get('/lead-scoring/clients').then(r => {



        const map = {};



        (r.data.data || []).forEach(s => { map[s.id] = s; });



        setScores(map);



      }).catch(() => { });



    }



  }, [canWrite, data.data]);







  const openAdd = () => {



    setForm(defaultForm);



    setCompanyIdSel('');



    setCreateDocForm({ doc_type: 'nda', doc_description: '', file: null });



    setError('');



    setGstinStatus({ checked: false, valid: null, state_name: '', state_code: '', pan: '', error_message: '' });



    setModal({ open: true, mode: 'add', item: null });



  };



  const openEdit = (c) => 



  { 



    setForm({



      ...c,



      name: c.name || '',



      trading_name: c.trading_name || '',



      type: c.type || 'generic_pharma',



      email: c.email || '',



      phone: c.phone || '',



      contact_person: c.contact_person || '',



      company_id_type: c.company_id_type || '',



      company_id_value: c.company_id_value || '',



      website: c.website || '',



      address: c.address || '',



      city: c.city || '',



      state: c.state || '',



      zip_code: c.zip_code || '',



      country: c.country || 'India',



      assigned_to: c.assigned_to || '',



      notes: c.notes || '',



      is_partner: !!c.is_partner,



      billing_same_as_primary: c.billing_same_as_primary !== 0,



      billing_address: c.billing_address || '',



      billing_city: c.billing_city || '',



      billing_state: c.billing_state || '',



      billing_zip_code: c.billing_zip_code || '',



      billing_country: c.billing_country || '',



      shipping_same_as_primary: c.shipping_same_as_primary !== 0,



      shipping_address: c.shipping_address || '',



      shipping_city: c.shipping_city || '',



      shipping_state: c.shipping_state || '',



      shipping_zip_code: c.shipping_zip_code || '',



      shipping_country: c.shipping_country || '',



      license_number: c.license_number || '',



      license_expiry_date: c.license_expiry_date ? c.license_expiry_date.slice(0, 10) : '',



      credit_limit: c.credit_limit != null ? c.credit_limit : '',



    });



    setCompanyIdSel(PREDEFINED_ID_TYPES.includes(c.company_id_type) ? c.company_id_type : (c.company_id_type ? 'OTHERS' : ''));



    setCreateDocForm({ doc_type: 'nda', doc_description: '', file: null });



    setError('');



    setGstinStatus({ checked: false, valid: null, state_name: '', state_code: '', pan: '', error_message: '' });



    setModal({ open: true, mode: 'edit', item: c });



  };







  const openView = async (c) => {



    setViewScore(null);



    setExtraAddresses([]);



    setAddrFormOpen(false);



    setAddrEditId(null);



    setAddrForm({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' });



    try {



      const [con, inq, docsRes, addrRes] = await Promise.all([



        api.get(`/clients/${c.id}/contacts`),



        api.get(`/clients/${c.id}/inquiries`),



        api.get(`/clients/${c.id}/documents`),



        api.get('/addresses', { params: { entity_type: 'client', entity_id: c.id } }),



      ]);



      setViewModal({ open: true, client: c, contacts: con.data.data || [], inquiries: inq.data.data || [] });



      setDocs(docsRes.data.data || []);



      setExtraAddresses(addrRes.data.data || []);

      loadPerms(c.id);



    } catch { setViewModal({ open: true, client: c, contacts: [], inquiries: [] }); setDocs([]); setExtraAddresses([]); setClientPerms([]); }



    setDocForm({ doc_type: 'nda', doc_description: '', file: null });



    setDocError('');



    api.get(`/lead-scoring/clients/${c.id}`).then(r => { if (r.data.success) setViewScore(r.data); }).catch(() => { });



  };







  const loadDocs = async (id) => {



    const { data } = await api.get(`/clients/${id}/documents`);



    setDocs(data.data || []);



  };

  const loadPerms = async (id) => {
    try {
      const { data } = await api.get(`/clients/${id}/permissions`);
      setClientPerms(data.data || []);
    } catch { setClientPerms([]); }
  };







  const loadExtraAddresses = async (id) => {



    const { data } = await api.get('/addresses', { params: { entity_type: 'client', entity_id: id } });



    setExtraAddresses(data.data || []);



  };







  const openAddrModal = async (c) => {



    setAddrFormOpen(false);



    setAddrEditId(null);



    setAddrForm({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' });



    setAddrModal({ open: true, entityId: c.id, entityName: c.name });



    const { data } = await api.get('/addresses', { params: { entity_type: 'client', entity_id: c.id } });



    setExtraAddresses(data.data || []);



  };







  const currentAddrEntityId = addrModal.open ? addrModal.entityId : viewModal.client?.id;







  const handleAddrSave = async () => {



    if (!addrForm.label.trim()) return;



    setAddrSaving(true);



    try {



      if (addrEditId) {



        await api.put(`/addresses/${addrEditId}`, addrForm);



      } else {



        await api.post('/addresses', { ...addrForm, entity_type: 'client', entity_id: currentAddrEntityId });



      }



      await loadExtraAddresses(currentAddrEntityId);



      setAddrFormOpen(false);



      setAddrEditId(null);



      setAddrForm({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' });



    } catch { /* ignore */ } finally { setAddrSaving(false); }



  };







  const handleAddrDelete = async (id) => {



    await api.delete(`/addresses/${id}`);



    await loadExtraAddresses(currentAddrEntityId);



  };







  const startAddrEdit = (addr) => {



    setAddrEditId(addr.id);



    setAddrForm({ label: addr.label, address_type: addr.address_type, address: addr.address || '', city: addr.city || '', state: addr.state || '', zip_code: addr.zip_code || '', country: addr.country || 'India' });



    setAddrFormOpen(true);



  };







  const handleDocUpload = async () => {



    if (!docForm.file) { setDocError('Please select a file.'); return; }



    if (docForm.doc_type === 'others' && !docForm.doc_description.trim()) { setDocError('Please describe the document type.'); return; }



    setDocUploading(true); setDocError('');



    try {



      const fd = new FormData();



      fd.append('file', docForm.file);



      fd.append('doc_type', docForm.doc_type);



      if (docForm.doc_description) fd.append('doc_description', docForm.doc_description);



      await api.post(`/clients/${viewModal.client.id}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });



      setDocForm({ doc_type: 'nda', doc_description: '', file: null });



      await loadDocs(viewModal.client.id);



    } catch (err) { setDocError(err.response?.data?.message || 'Upload failed.'); }



    finally { setDocUploading(false); }



  };







  const handleDocDelete = async (docId) => {



    if (!window.confirm('Delete this document?')) return;



    await api.delete(`/clients/${viewModal.client.id}/documents/${docId}`);



    await loadDocs(viewModal.client.id);



  };







  const handleDocDownload = (docId, name) => {



    const token = localStorage.getItem('token');



    fetch(`${process.env.REACT_APP_API_URL || '/api'}/clients/${viewModal.client.id}/documents/${docId}/download`,



      { headers: { Authorization: `Bearer ${token}` } })



      .then(r => r.blob()).then(blob => { const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name; a.click(); });



  };







  const docTypeIcon = (filename = '') => {



    const ext = filename.split('.').pop().toLowerCase();



    if (ext === 'pdf') return '📄';



    if (['doc', 'docx'].includes(ext)) return '📝';



    if (['xls', 'xlsx'].includes(ext)) return '📊';



    if (['png', 'jpg', 'jpeg', 'webp'].includes(ext)) return '🖼️';



    return '📎';



  };







  const handleGeneratePortal = async (clientId) => {



    try {



      const { data } = await api.post(`/portal/admin/clients/${clientId}/portal/generate`);



      setPortalLink(data.portal_url);



      setPortalLinkClientId(clientId);



      // Update viewModal client to show portal_enabled



      setViewModal(prev => ({ ...prev, client: { ...prev.client, portal_enabled: true } }));



    } catch { setError('Failed to generate portal link.'); }



  };







  const handleRegeneratePortal = async (clientId) => {



    await handleGeneratePortal(clientId);



  };







  const handleDisablePortal = async (clientId) => {



    try {



      await api.delete(`/portal/admin/clients/${clientId}/portal`);



      setPortalLink('');



      setPortalLinkClientId(null);



      setViewModal(prev => ({ ...prev, client: { ...prev.client, portal_enabled: false } }));



    } catch { setError('Failed to disable portal.'); }



  };







  const handleSave = async (skipDupCheck = false) => {



    if (!form.name || !form.type) { setError('Name and type are required.'); return; }



    // Duplicate check on new records only



    if (modal.mode === 'add' && !skipDupCheck) {



      try {



        const duplicateParams = { search: form.name.trim(), limit: 5 };



        // Apply same role-based filtering in duplicate check

        if (!isAdmin && user?.id) {

          duplicateParams.assigned_to = user.id;

        }



        const { data: res } = await api.get('/clients', { params: duplicateParams });



        const matches = (res.data || []).filter(c =>



          c.name.toLowerCase().includes(form.name.trim().toLowerCase()) ||



          form.name.trim().toLowerCase().includes(c.name.toLowerCase())



        );



        if (matches.length > 0) {



          setDupWarning({ open: true, matches });



          return;



        }



      } catch { /* proceed if check fails */ }



    }



    setSaving(true); setError('');



    try {



      let clientId;



      if (modal.mode === 'add') {



        const res = await api.post('/clients', form);



        clientId = res.data.data.id;



      } else {



        await api.put(`/clients/${modal.item.id}`, form);



        clientId = modal.item.id;



      }



      if (createDocForm.file) {



        try {



          const fd = new FormData();



          fd.append('file', createDocForm.file);



          fd.append('doc_type', createDocForm.doc_type || 'others');



          if (createDocForm.doc_description) fd.append('doc_description', createDocForm.doc_description);



          await api.post(`/clients/${clientId}/documents`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });



        } catch (docErr) {



          setError(`Record saved but document upload failed: ${docErr.response?.data?.message || 'Upload error'}`);



          setSaving(false);



          load();



          return;



        }



      }



      setModal({ open: false }); load();



    } catch (err) { setError(err.response?.data?.message || 'Failed to save client.'); }



    finally { setSaving(false); }



  };







  const handleDelete = async () => {



    try { await api.delete(`/clients/${deleteConfirm.id}`); }



    catch { /* freeze, ignore */ }



    setDeleteConfirm(null); load();



  };







  const handleUnfreeze = async (id) => {



    try { await api.patch(`/clients/${id}/unfreeze`); load(); setModal({ open: false }); }



    catch (err) { setError(err.response?.data?.message || 'Failed to unfreeze.'); }



  };



  const handleApprove = async (id) => {

    try { await api.patch(`/clients/${id}/approve`); load(); }

    catch (err) { alert(err.response?.data?.message || 'Failed to approve.'); }

  };



  const handleReject = async (id) => {

    if (!window.confirm('Reject this client? They will not be usable in orders or quotes.')) return;

    try { await api.patch(`/clients/${id}/reject`); load(); }

    catch (err) { alert(err.response?.data?.message || 'Failed to reject.'); }

  };







  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));







  return (



    <div className="page">



      <div className="page-header">



        <div>



          <h1 className="page-title">Clients</h1>



          <p className="page-subtitle">Pharma companies, CROs, biotechs and research institutions</p>



        </div>



        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>



          {canWrite && (
            <>
              {/* Commented out bulk upload for both user & admin
              <button className="btn btn-secondary" onClick={() => setBulkOpen(true)}>
                <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>
                Bulk Upload
              </button>
              */}
              <button className="btn btn-primary" onClick={openAdd}>
                <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
                Add Client
              </button>
            </>
          )}



        </div>



      </div>







      <div className="card" style={{ marginBottom: 16 }}>



        <div className="card-body" style={{ padding: '14px 16px' }}>



          <div className="search-bar">



            <div className="search-input-wrap">



              <span className="search-icon"><svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg></span>



              <input className="form-control" placeholder="Search name, email, city…" value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />



            </div>



            <select className="form-control form-select" style={{ width: 200 }} value={typeFilter} onChange={e => { setTypeFilter(e.target.value); setPage(1); }}>



              <option value="">All Types</option>



              {CLIENT_TYPES.map(t => <option key={t} value={t}>{typeLbl(t)}</option>)}



            </select>

            {(isAdmin || isManager) && (
              <select className="form-control form-select" style={{ width: 160 }} value={approvalFilter} onChange={e => { setApprovalFilter(e.target.value); setPage(1); }}>
                <option value="">All Status</option>
                <option value="pending">Pending Approval</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            )}



            {(search || typeFilter || approvalFilter) && <button className="btn btn-ghost btn-sm" onClick={() => { setSearch(''); setTypeFilter(''); setApprovalFilter(''); setPage(1); }}>Clear</button>}



          </div>



        </div>



      </div>







      {/* Pending approval banner for admin/manager */}
      {(isAdmin || isManager) && data.data.some(c => c.approval_status === 'pending') && !approvalFilter && (
        <div style={{ marginBottom: 12, padding: '10px 16px', borderRadius: 8, background: '#fef3c7', border: '1px solid #fcd34d', color: '#92400e', display: 'flex', alignItems: 'center', gap: 10, fontSize: '0.86rem' }}>
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
          <span>
            <strong>{data.data.filter(c => c.approval_status === 'pending').length} client(s)</strong> are pending your approval.
            <button className="btn btn-ghost btn-sm" style={{ marginLeft: 10, padding: '2px 10px', color: '#92400e', border: '1px solid #fcd34d' }} onClick={() => { setApprovalFilter('pending'); setPage(1); }}>View Pending</button>
          </span>
        </div>
      )}

      <div className="card">



        <div className="table-container">



          <table className="table">



            <thead><tr><th>Client</th><th>Type</th><th>Phone</th><th>Address</th><th>City</th><th>Country</th><th>Credit</th><th>BD Owner</th><th>Actions</th></tr></thead>



            <tbody>



              {loading && <tr><td colSpan={9} style={{ padding: 0 }}><SkeletonTable rows={8} cols={9}  /></td></tr>}



              {!loading && data.data.length === 0 && <tr><td colSpan={9}><div className="empty-state"><p>No clients found. Add your first client.</p></div></td></tr>}



              {!loading && data.data.map(c => (



                <tr key={c.id}>



                  <td>



                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>



                      {(() => {



                        const [fg] = getAvatarColors(c.name);



                        const initials = c.name.split(' ').slice(0, 2).map(w => w[0]?.toUpperCase() || '').join('');



                        return (



                          <div style={{ width: 36, height: 36, borderRadius: 10, flexShrink: 0, background: `linear-gradient(135deg, ${fg}20, ${fg}38)`, border: `1.5px solid ${fg}33`, color: fg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: '0.78rem' }}>



                            {initials}



                          </div>



                        );



                      })()}



                      <div>



                        <div style={{ fontWeight: 600, color: c.is_active === 0 ? 'var(--text-muted)' : undefined }}>



                          {c.name}



                          {c.is_active === 0 && <span className="badge badge-neutral" style={{ fontSize: '0.65rem', marginLeft: 6 }}>Frozen</span>}

                          {c.approval_status === 'pending' && (
                            <span style={{ fontSize: '0.62rem', fontWeight: 700, marginLeft: 6, padding: '1px 6px', borderRadius: 8, background: '#fef3c7', color: '#92400e', border: '1px solid #fcd34d' }}>PENDING APPROVAL</span>
                          )}

                          {c.approval_status === 'rejected' && (
                            <span style={{ fontSize: '0.62rem', fontWeight: 700, marginLeft: 6, padding: '1px 6px', borderRadius: 8, background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' }}>REJECTED</span>
                          )}

                          {!!c.is_partner && <span style={{ fontSize: '0.62rem', fontWeight: 700, marginLeft: 6, padding: '1px 6px', borderRadius: 8, background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' }}>PARTNER</span>}



                          {scores[c.id] && <span style={{ marginLeft: 6 }}><LeadScoreBadge score={scores[c.id].score} grade={scores[c.id].grade} /></span>}



                        </div>



                        {c.email && <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{c.email}</div>}



                      </div>



                    </div>



                  </td>



                  <td><span className={`badge badge-${typeColors[c.type] || 'neutral'}`}>{typeLbl(c.type)}</span></td>



                  <td style={{ color: 'var(--text-secondary)' }}>{c.phone || '—'}</td>



                  <td style={{ fontSize: '0.75rem', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={c.address || ''}>

                    {c.address || '—'}

                  </td>



                  <td>{c.city || '—'}</td>



                  <td style={{ color: 'var(--text-secondary)' }}>{c.country || '—'}</td>



                  <td style={{ fontSize: '0.78rem' }}>



                    {c.credit_limit != null ? (



                      <div>



                        <div style={{ color: 'var(--text-secondary)' }}>Limit: &#8377;{Number(c.credit_limit).toLocaleString()}</div>



                        {c.outstanding > c.credit_limit && <span className="badge badge-danger" style={{ fontSize: '0.65rem' }}>OVERLIMIT</span>}



                      </div>



                    ) : '—'}



                  </td>



                  <td style={{ color: 'var(--text-secondary)', fontSize: '0.83rem' }}>{c.assigned_to_name || '—'}</td>



                  <td>
                    <div className="table-actions">
                      <button className="btn btn-ghost btn-icon" data-tooltip="View Details" onClick={() => openView(c)}>
                        <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>
                      </button>

                      {canWrite && (
                        <button className="btn btn-ghost btn-icon" data-tooltip="Manage Addresses" onClick={() => openAddrModal(c)}>
                          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                        </button>
                      )}

                      {canWrite && isAdmin && (
                        <button className="btn btn-ghost btn-icon" data-tooltip="Edit" onClick={() => openEdit(c)}>
                          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
                        </button>
                      )}

                      {canWrite && isAdmin && (
                        <button
                          className="btn btn-ghost btn-icon"
                          data-tooltip={c.is_partner ? 'Remove Partner' : 'Mark as Partner'}
                          style={{ color: c.is_partner ? '#15803d' : '#cbd5e1' }}
                          onClick={async () => {
                            await api.patch(`/clients/${c.id}/partner`);
                            load();
                          }}
                        >
                          <svg width="15" height="15" fill={c.is_partner ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" />
                          </svg>
                        </button>
                      )}

                      {(isAdmin || isManager) && c.approval_status === 'pending' && (
                        <>
                          <button
                            className="btn btn-ghost btn-icon"
                            data-tooltip="Approve"
                            style={{ color: '#15803d' }}
                            onClick={() => handleApprove(c.id)}
                          >
                            <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                          </button>
                          <button
                            className="btn btn-ghost btn-icon"
                            data-tooltip="Reject"
                            style={{ color: '#dc2626' }}
                            onClick={() => handleReject(c.id)}
                          >
                            <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                          </button>
                        </>
                      )}

                      {(isAdmin || isManager) && c.approval_status === 'rejected' && (
                        <button
                          className="btn btn-ghost btn-icon"
                          data-tooltip="Re-approve"
                          style={{ color: '#15803d' }}
                          onClick={() => handleApprove(c.id)}
                        >
                          <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
                        </button>
                      )}

                      {canWrite && c.is_active !== 0 && (
                        <button className="btn btn-ghost btn-icon" data-tooltip="Freeze" style={{ color: 'var(--error)' }} onClick={() => setDeleteConfirm(c)}>
                          <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" /></svg>
                        </button>
                      )}
                    </div>
                  </td>



                </tr>



              ))}



            </tbody>



          </table>



        </div>



        <Pagination page={data.page} total={data.total} limit={data.limit} onPageChange={setPage} />



      </div>







      {/* Duplicate Warning Modal */}



      {dupWarning.open && (



        <Modal open={dupWarning.open} onClose={() => setDupWarning({ open: false, matches: [] })}



          title="Possible Duplicate Detected"



          footer={<>



            <button className="btn btn-secondary" onClick={() => setDupWarning({ open: false, matches: [] })}>Cancel</button>



            <button className="btn btn-primary" onClick={() => { setDupWarning({ open: false, matches: [] }); handleSave(true); }}>Save Anyway</button>



          </>}



        >



          <div style={{ marginBottom: 12, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '10px 14px', fontSize: 14 }}>



            The following client(s) with a similar name already exist. Are you sure you want to create a new record?



          </div>



          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 14, color: '#374151' }}>



            {dupWarning.matches.map(m => (



              <li key={m.id} style={{ marginBottom: 4 }}>



                <b>{m.name}</b> &nbsp;·&nbsp; {typeLbl(m.type)} &nbsp;·&nbsp; {m.city || m.country || ''}



              </li>



            ))}



          </ul>



        </Modal>



      )}







      {/* Add/Edit Modal */}



      <Modal open={modal.open} onClose={() => setModal({ open: false })} title={modal.mode === 'add' ? 'Add Client' : 'Edit Client'} size="lg"



        footer={<>



          <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>Cancel</button>



          {modal.item?.is_active === 0



            ? <button className="btn btn-primary" style={{ background: '#dc2626' }} onClick={() => handleUnfreeze(modal.item.id)}>Unfreeze</button>



            : <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? <><div className="spinner" style={{ width: 14, height: 14 }} /> Saving…</> : 'Save Client'}</button>



          }



        </>}



      >



        {error && <div className="alert alert-error">{error}</div>}



        {modal.item?.is_active === 0 && (



          <div style={{ marginBottom: 16, padding: '12px 16px', background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>



            <div>



              <div style={{ fontWeight: 700, color: '#dc2626', fontSize: '0.875rem' }}>⛔ Record Frozen</div>



              <div style={{ color: '#991b1b', fontSize: '0.8rem', marginTop: 2 }}>This record is frozen and cannot be edited. Unfreeze to make changes.</div>



            </div>



          </div>



        )}



        <div className="form-row">



          <div className="form-group">



            <label className="form-label">Company Name *</label>



            <input className="form-control" value={form.name} onChange={e => f('name', e.target.value)} placeholder="Sun Pharma Ltd." disabled={modal.item?.is_active === 0} />



          </div>



          <div className="form-group">



            <label className="form-label">Trading Name</label>



            <input className="form-control" value={form.trading_name} onChange={e => f('trading_name', e.target.value)} placeholder="Sun Pharma (short/trade name)" disabled={modal.item?.is_active === 0} />



          </div>



        </div>



        <div className="form-row">



          <div className="form-group"><label className="form-label">Type *</label>



            <select className="form-control form-select" value={form.type} onChange={e => f('type', e.target.value)} disabled={modal.item?.is_active === 0}>



              {CLIENT_TYPES.map(t => <option key={t} value={t}>{typeLbl(t)}</option>)}



            </select>



          </div>



          <div className="form-group"><label className="form-label">Contact Person</label><input className="form-control" value={form.contact_person} onChange={e => f('contact_person', e.target.value)} placeholder="e.g. Mr. Rajesh Kumar" disabled={modal.item?.is_active === 0} /></div>



        </div>



        <div className="form-row">



          <div className="form-group"><label className="form-label">Email</label><input className="form-control" type="email" value={form.email} onChange={e => f('email', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



          <div className="form-group"><label className="form-label">Phone</label><input className="form-control" value={form.phone} onChange={e => f('phone', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



        </div>



        <div className="form-row">



          <div className="form-group">



            <label className="form-label">Company ID Type</label>



            <select className="form-control form-select" value={companyIdSel} disabled={modal.item?.is_active === 0} onChange={e => {



              setCompanyIdSel(e.target.value);



              if (e.target.value !== 'OTHERS') f('company_id_type', e.target.value);



              else f('company_id_type', '');



            }}>



              <option value="">-- Select --</option>



              {ID_TYPES.map(t => <option key={t} value={t}>{t}</option>)}



            </select>



          </div>



          <div className="form-group">



            <label className="form-label">{companyIdSel === 'OTHERS' ? 'Custom ID Type *' : 'Company ID Value'}</label>



            {companyIdSel === 'OTHERS' ? (



              <div style={{ display: 'flex', gap: 8 }}>



                <input className="form-control" value={form.company_id_type} onChange={e => f('company_id_type', e.target.value)} placeholder="e.g. PAN, VAT, CIN…" style={{ flex: 1 }} disabled={modal.item?.is_active === 0} />



                <input className="form-control" value={form.company_id_value} onChange={e => f('company_id_value', e.target.value)} placeholder="ID number" style={{ flex: 1 }} disabled={modal.item?.is_active === 0} />



              </div>



            ) : companyIdSel === 'GSTN' ? (



              <>



                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>



                  <input



                    className="form-control"



                    value={form.company_id_value}



                    onChange={e => {



                      f('company_id_value', e.target.value.toUpperCase());



                      setGstinStatus({ checked: false, valid: null, state_name: '', state_code: '', pan: '', error_message: '' });



                    }}



                    onBlur={e => validateGstin(e.target.value)}



                    placeholder="e.g. 36AAAPL1234C1Z5"



                    maxLength={15}



                    style={{ flex: 1, fontFamily: 'monospace', letterSpacing: '0.5px', textTransform: 'uppercase' }}



                    disabled={modal.item?.is_active === 0}



                  />



                  <button



                    type="button"



                    className="btn btn-secondary btn-sm"



                    style={{ whiteSpace: 'nowrap', flexShrink: 0 }}



                    disabled={modal.item?.is_active === 0 || gstinValidating || !form.company_id_value}



                    onClick={() => validateGstin(form.company_id_value)}



                  >



                    {gstinValidating



                      ? <><div className="spinner" style={{ width: 12, height: 12, display: 'inline-block', marginRight: 4 }} /> Checking…</>



                      : 'Validate'



                    }



                  </button>



                </div>



                {gstinStatus.checked && gstinStatus.valid && (



                  <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>



                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#16a34a', fontSize: '0.8rem', fontWeight: 600 }}>



                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12" /></svg>



                      Valid GSTIN



                    </span>



                    <span style={{ padding: '2px 10px', borderRadius: 20, background: '#dcfce7', color: '#15803d', fontSize: '0.77rem', fontWeight: 700, border: '1px solid #bbf7d0' }}>



                      {gstinStatus.state_name} ({gstinStatus.state_code})



                    </span>



                    {gstinStatus.pan && (



                      <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>



                        PAN: <strong style={{ color: 'var(--text-secondary)', fontFamily: 'monospace' }}>{gstinStatus.pan}</strong>



                      </span>



                    )}



                  </div>



                )}



                {gstinStatus.checked && !gstinStatus.valid && (



                  <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 4, color: '#dc2626', fontSize: '0.8rem' }}>



                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" /></svg>



                    {gstinStatus.error_message || 'Invalid GSTIN format'}



                  </div>



                )}



              </>



            ) : (

              <input className="form-control" value={form.company_id_value} onChange={e => f('company_id_value', e.target.value)} placeholder="ID number / value" disabled={modal.item?.is_active === 0} />

            )}

          </div>

        </div>



        <div className="form-row">

          <div className="form-group"><label className="form-label">Website</label><input className="form-control" value={form.website} onChange={e => f('website', e.target.value)} placeholder="https://example.com" disabled={modal.item?.is_active === 0} /></div>



          <div className="form-group">

            <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: 5 }}>

              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>

              BD Owner (Sales Person)

            </label>

            <select className="form-control form-select" value={form.assigned_to} onChange={e => f('assigned_to', e.target.value)} disabled={modal.item?.is_active === 0} style={{ fontWeight: 500 }}>

              <option value="">-- Unassigned / Selection --</option>

              {users

                .filter(u => ['bd', 'sales', 'mr', 'manager', 'admin', 'director', 'procurement'].includes(u.role))

                .sort((a, b) => a.name.localeCompare(b.name))

                .map(u => (

                  <option key={u.id} value={u.id}>

                    {u.name} ({u.role === 'mr' ? 'MR' : u.role === 'bd' ? 'BD' : u.role === 'director' ? 'Director' : u.role === 'procurement' ? 'Procurement' : u.role.charAt(0).toUpperCase() + u.role.slice(1)})

                  </option>

                ))

              }

            </select>

          </div>

        </div>



        {/* Primary Address */}



        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>



          <div style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 8 }}>Primary Address</div>



          <div className="form-group"><label className="form-label">Address</label><textarea className="form-control" rows={2} value={form.address} onChange={e => f('address', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



          <div className="form-row">



            <div className="form-group">

              <label className="form-label">City</label>

              {form.country === 'India' && form.state && MAJOR_CITIES[form.state] ? (

                <select className="form-control" value={form.city} onChange={e => f('city', e.target.value)} disabled={modal.item?.is_active === 0}>

                  <option value="">-- Select City --</option>

                  {MAJOR_CITIES[form.state].map(city => <option key={city} value={city}>{city}</option>)}

                </select>

              ) : (

                <input className="form-control" value={form.city} onChange={e => f('city', e.target.value)} disabled={modal.item?.is_active === 0} placeholder="Enter city" />

              )}

            </div>



            <div className="form-group"><label className="form-label">State</label>



              {form.country === 'India' || !form.country



                ? <select className="form-control" value={form.state} onChange={e => f('state', e.target.value)} disabled={modal.item?.is_active === 0}>



                  <option value="">— Select State —</option>



                  {INDIAN_STATES.map(s => <option key={s.code} value={s.name}>{s.name}</option>)}



                </select>



                : <input className="form-control" value={form.state} onChange={e => f('state', e.target.value)} disabled={modal.item?.is_active === 0} />



              }



            </div>



          </div>



          <div className="form-row">



            <div className="form-group"><label className="form-label">Zip Code</label><input className="form-control" value={form.zip_code} onChange={e => f('zip_code', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



            <div className="form-group"><label className="form-label">Country</label>



              <select className="form-control" value={form.country} onChange={e => { f('country', e.target.value); if (e.target.value !== 'India') f('state', ''); }} disabled={modal.item?.is_active === 0}>



                <option value="">— Select Country —</option>



                {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}



              </select>



            </div>



          </div>



        </div>



        {/* Billing Address */}



        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>



          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>



            <div style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Billing Address</div>



            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: '0.82rem', color: 'var(--text-secondary)', fontWeight: 500 }}>



              <input type="checkbox" checked={!!form.billing_same_as_primary} disabled={modal.item?.is_active === 0}



                onChange={e => f('billing_same_as_primary', e.target.checked)} />



              Same as Primary



            </label>



          </div>



          {form.billing_same_as_primary



            ? <div style={{ padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 6, fontSize: '0.82rem', color: 'var(--text-muted)' }}>Uses primary address</div>



            : <>



              <div className="form-group"><label className="form-label">Billing Address</label><textarea className="form-control" rows={2} value={form.billing_address} onChange={e => f('billing_address', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



              <div className="form-row">



                <div className="form-group">

                  <label className="form-label">City</label>

                  {form.billing_country === 'India' && form.billing_state && MAJOR_CITIES[form.billing_state] ? (

                    <select className="form-control" value={form.billing_city} onChange={e => f('billing_city', e.target.value)} disabled={modal.item?.is_active === 0}>

                      <option value="">-- Select City --</option>

                      {MAJOR_CITIES[form.billing_state].map(city => <option key={city} value={city}>{city}</option>)}

                    </select>

                  ) : (

                    <input className="form-control" value={form.billing_city} onChange={e => f('billing_city', e.target.value)} disabled={modal.item?.is_active === 0} placeholder="Enter city" />

                  )}

                </div>



                <div className="form-group"><label className="form-label">State</label>



                  {form.billing_country === 'India' || !form.billing_country



                    ? <select className="form-control" value={form.billing_state} onChange={e => f('billing_state', e.target.value)} disabled={modal.item?.is_active === 0}>



                      <option value="">— Select State —</option>



                      {INDIAN_STATES.map(s => <option key={s.code} value={s.name}>{s.name}</option>)}



                    </select>



                    : <input className="form-control" value={form.billing_state} onChange={e => f('billing_state', e.target.value)} disabled={modal.item?.is_active === 0} />



                  }



                </div>



              </div>



              <div className="form-row">



                <div className="form-group"><label className="form-label">Zip Code</label><input className="form-control" value={form.billing_zip_code} onChange={e => f('billing_zip_code', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



                <div className="form-group"><label className="form-label">Country</label>



                  <select className="form-control" value={form.billing_country} onChange={e => { f('billing_country', e.target.value); if (e.target.value !== 'India') f('billing_state', ''); }} disabled={modal.item?.is_active === 0}>



                    <option value="">— Select Country —</option>



                    {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}



                  </select>



                </div>



              </div>



            </>



          }



        </div>



        {/* Shipping Address */}



        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>



          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>



            <div style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Shipping Address</div>



            <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: '0.82rem', color: 'var(--text-secondary)', fontWeight: 500 }}>



              <input type="checkbox" checked={!!form.shipping_same_as_primary} disabled={modal.item?.is_active === 0}



                onChange={e => f('shipping_same_as_primary', e.target.checked)} />



              Same as Primary



            </label>



          </div>



          {form.shipping_same_as_primary



            ? <div style={{ padding: '8px 12px', background: 'var(--bg-secondary)', borderRadius: 6, fontSize: '0.82rem', color: 'var(--text-muted)' }}>Uses primary address</div>



            : <>



              <div className="form-group"><label className="form-label">Shipping Address</label><textarea className="form-control" rows={2} value={form.shipping_address} onChange={e => f('shipping_address', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



              <div className="form-row">



                <div className="form-group">

                  <label className="form-label">City</label>

                  {form.shipping_country === 'India' && form.shipping_state && MAJOR_CITIES[form.shipping_state] ? (

                    <select className="form-control" value={form.shipping_city} onChange={e => f('shipping_city', e.target.value)} disabled={modal.item?.is_active === 0}>

                      <option value="">-- Select City --</option>

                      {MAJOR_CITIES[form.shipping_state].map(city => <option key={city} value={city}>{city}</option>)}

                    </select>

                  ) : (

                    <input className="form-control" value={form.shipping_city} onChange={e => f('shipping_city', e.target.value)} disabled={modal.item?.is_active === 0} placeholder="Enter city" />

                  )}

                </div>



                <div className="form-group"><label className="form-label">State</label>



                  {form.shipping_country === 'India' || !form.shipping_country



                    ? <select className="form-control" value={form.shipping_state} onChange={e => f('shipping_state', e.target.value)} disabled={modal.item?.is_active === 0}>



                      <option value="">— Select State —</option>



                      {INDIAN_STATES.map(s => <option key={s.code} value={s.name}>{s.name}</option>)}



                    </select>



                    : <input className="form-control" value={form.shipping_state} onChange={e => f('shipping_state', e.target.value)} disabled={modal.item?.is_active === 0} />



                  }



                </div>



              </div>



              <div className="form-row">



                <div className="form-group"><label className="form-label">Zip Code</label><input className="form-control" value={form.shipping_zip_code} onChange={e => f('shipping_zip_code', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



                <div className="form-group"><label className="form-label">Country</label>



                  <select className="form-control" value={form.shipping_country} onChange={e => { f('shipping_country', e.target.value); if (e.target.value !== 'India') f('shipping_state', ''); }} disabled={modal.item?.is_active === 0}>



                    <option value="">— Select Country —</option>



                    {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}



                  </select>



                </div>



              </div>



            </>



          }



        </div>



        <div className="form-group" style={{ marginTop: 4 }}><label className="form-label">Notes</label><textarea className="form-control" rows={2} value={form.notes} onChange={e => f('notes', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 12, marginTop: 4 }}>



          <div style={{ fontWeight: 700, fontSize: '0.82rem', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 8 }}>License & Credit</div>



          <div className="form-row">



            <div className="form-group"><label className="form-label">Drug License Number</label><input className="form-control" value={form.license_number} onChange={e => f('license_number', e.target.value)} placeholder="DL-MH-12345" disabled={modal.item?.is_active === 0} /></div>



            <div className="form-group"><label className="form-label">License Expiry Date</label><input className="form-control" type="date" value={form.license_expiry_date} onChange={e => f('license_expiry_date', e.target.value)} disabled={modal.item?.is_active === 0} /></div>



          </div>



          <div className="form-row">



            <div className="form-group"><label className="form-label">Credit Limit (&#8377;)</label><input className="form-control" type="number" value={form.credit_limit} onChange={e => f('credit_limit', e.target.value)} placeholder="e.g. 500000" disabled={modal.item?.is_active === 0} /></div>



          </div>



        </div>



        <div style={{ borderTop: '1px solid var(--border)', paddingTop: 14, marginTop: 4 }}>



          <div style={{ fontWeight: 600, fontSize: '0.85rem', marginBottom: 10, color: 'var(--text-secondary)' }}>Attach Document (optional)</div>



          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>



            <div className="form-group" style={{ marginBottom: 0, minWidth: 140 }}>



              <label className="form-label" style={{ fontSize: '0.78rem' }}>Document Type</label>



              <select className="form-control form-select" style={{ fontSize: '0.83rem' }} value={createDocForm.doc_type}



                onChange={e => setCreateDocForm(p => ({ ...p, doc_type: e.target.value, doc_description: '' }))}>



                <option value="nda">NDA</option>



                <option value="business_reg">Business Registration</option>



                <option value="gst_cert">GST Certificate</option>



                <option value="drug_license">Drug License</option>



                <option value="pan_card">PAN Card</option>



                <option value="agreement">Agreement / Contract</option>



                <option value="others">Others</option>



              </select>



            </div>



            {createDocForm.doc_type === 'others' && (



              <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 130 }}>



                <label className="form-label" style={{ fontSize: '0.78rem' }}>Describe Type</label>



                <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="e.g. NDA, Agreement…"



                  value={createDocForm.doc_description} onChange={e => setCreateDocForm(p => ({ ...p, doc_description: e.target.value }))} />



              </div>



            )}



            <div className="form-group" style={{ marginBottom: 0, flex: 2, minWidth: 160 }}>



              <label className="form-label" style={{ fontSize: '0.78rem' }}>File</label>



              <input type="file" className="form-control" style={{ fontSize: '0.83rem' }}



                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.webp,.txt"



                onChange={e => setCreateDocForm(p => ({ ...p, file: e.target.files[0] || null }))} />



            </div>



          </div>



        </div>



      </Modal>







      {/* View Modal */}



      <Modal open={viewModal.open} onClose={() => setViewModal({ open: false })} title="Client Details" size="lg"



        footer={<button className="btn btn-secondary" onClick={() => setViewModal({ open: false })}>Close</button>}



      >



        {viewModal.client && (



          <>



            <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', marginBottom: 18 }}>



              <div style={{ width: 52, height: 52, borderRadius: 12, background: 'var(--primary-lighter)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.2rem', color: 'var(--primary)', flexShrink: 0 }}>



                {viewModal.client.name.charAt(0)}



              </div>



              <div>



                <div style={{ fontWeight: 700, fontSize: '1.05rem' }}>{viewModal.client.name}</div>



                {viewModal.client.website && <div style={{ fontSize: '0.8rem', color: 'var(--primary)' }}>{viewModal.client.website}</div>}



                <div style={{ display: 'flex', gap: 6, marginTop: 4, flexWrap: 'wrap', alignItems: 'center' }}>



                  <span className={`badge badge-${typeColors[viewModal.client.type] || 'neutral'}`}>{typeLbl(viewModal.client.type)}</span>



                  {viewScore && <LeadScoreBadge score={viewScore.score} grade={viewScore.grade} />}



                </div>



              </div>



            </div>



            {viewScore && (



              <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px', marginBottom: 16 }}>



                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>



                  <div>



                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Lead Score</div>



                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, marginTop: 2 }}>



                      <span style={{ fontSize: '1.8rem', fontWeight: 800, lineHeight: 1, color: 'var(--text-primary)' }}>{viewScore.score}</span>



                      <span style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>/100</span>



                      <LeadScoreBadge score={viewScore.score} grade={viewScore.grade} />



                    </div>



                  </div>



                  <div style={{ flex: 1 }}>



                    <div style={{ height: 6, borderRadius: 6, background: 'var(--border)', overflow: 'hidden' }}>



                      <div style={{ height: '100%', borderRadius: 6, width: `${viewScore.score}%`, background: viewScore.grade === 'A' ? '#22c55e' : viewScore.grade === 'B' ? '#3b82f6' : viewScore.grade === 'C' ? '#f59e0b' : viewScore.grade === 'D' ? '#f97316' : '#ef4444', transition: 'width 0.4s ease' }} />



                    </div>



                  </div>



                </div>



                {viewScore.factors && viewScore.factors.length > 0 && (



                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>



                    {viewScore.factors.map((f, i) => (



                      <span key={i} style={{ fontSize: '0.72rem', padding: '2px 8px', borderRadius: 8, background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0', fontWeight: 500 }}>



                        {f}



                      </span>



                    ))}



                  </div>



                )}



              </div>



            )}



            <div className="detail-grid" style={{ marginBottom: 16 }}>



              {viewModal.client.trading_name && (



                <div className="detail-item"><span className="detail-label">Trading Name</span><span className="detail-value">{viewModal.client.trading_name}</span></div>



              )}



              {viewModal.client.contact_person && (



                <div className="detail-item"><span className="detail-label">Contact Person</span><span className="detail-value">{viewModal.client.contact_person}</span></div>



              )}



              <div className="detail-item"><span className="detail-label">Email</span><span className="detail-value">{viewModal.client.email || '—'}</span></div>



              <div className="detail-item"><span className="detail-label">Phone</span><span className="detail-value">{viewModal.client.phone || '—'}</span></div>



              <div className="detail-item"><span className="detail-label">BD Owner</span><span className="detail-value">{viewModal.client.assigned_to_name || '—'}</span></div>



              {viewModal.client.company_id_type && (



                <div className="detail-item"><span className="detail-label">Company ID</span><span className="detail-value"><span style={{ fontWeight: 700, color: 'var(--primary)', marginRight: 4 }}>{viewModal.client.company_id_type}</span>{viewModal.client.company_id_value || '—'}</span></div>



              )}



            </div>



            {/* Address sections */}



            {(() => {



              const c = viewModal.client;



              const primaryAddr = [c.address, c.city, c.state, c.zip_code, c.country].filter(Boolean).join(', ') || '—';



              const billingAddr = c.billing_same_as_primary !== 0



                ? null



                : [c.billing_address, c.billing_city, c.billing_state, c.billing_zip_code, c.billing_country].filter(Boolean).join(', ') || '—';



              const shippingAddr = c.shipping_same_as_primary !== 0



                ? null



                : [c.shipping_address, c.shipping_city, c.shipping_state, c.shipping_zip_code, c.shipping_country].filter(Boolean).join(', ') || '—';



              return (



                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 10, marginBottom: 16 }}>



                  <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: '10px 14px', border: '1px solid var(--border)' }}>



                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 4, letterSpacing: '0.4px' }}>Primary Address</div>



                    <div style={{ fontSize: '0.83rem', color: 'var(--text-primary)' }}>{primaryAddr}</div>



                  </div>



                  <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: '10px 14px', border: '1px solid var(--border)' }}>



                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 4, letterSpacing: '0.4px' }}>Billing Address</div>



                    {billingAddr === null



                      ? <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>Same as Primary</div>



                      : <div style={{ fontSize: '0.83rem', color: 'var(--text-primary)' }}>{billingAddr}</div>



                    }



                  </div>



                  <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: '10px 14px', border: '1px solid var(--border)' }}>



                    <div style={{ fontSize: '0.72rem', fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', marginBottom: 4, letterSpacing: '0.4px' }}>Shipping Address</div>



                    {shippingAddr === null



                      ? <div style={{ fontSize: '0.82rem', color: 'var(--text-muted)', fontStyle: 'italic' }}>Same as Primary</div>



                      : <div style={{ fontSize: '0.83rem', color: 'var(--text-primary)' }}>{shippingAddr}</div>



                    }



                  </div>



                </div>



              );



            })()}



            {/* Additional Addresses */}



            <div style={{ marginTop: 4, marginBottom: 16, borderTop: '1px solid var(--border)', paddingTop: 14 }}>



              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>



                <div style={{ fontWeight: 700, fontSize: '0.88rem' }}>Additional Addresses ({extraAddresses.length})</div>



                {canWrite && !addrFormOpen && (



                  <button className="btn btn-sm btn-primary" style={{ fontSize: '0.78rem' }} onClick={() => { setAddrEditId(null); setAddrForm({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' }); setAddrFormOpen(true); }}>



                    + Add Address



                  </button>



                )}



              </div>



              {addrFormOpen && (



                <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 8, padding: 14, marginBottom: 12 }}>



                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Label *</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="e.g. Head Office, Warehouse" value={addrForm.label} onChange={e => setAddrForm(p => ({ ...p, label: e.target.value }))} />



                    </div>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Type</label>



                      <select className="form-control form-select" style={{ fontSize: '0.83rem' }} value={addrForm.address_type} onChange={e => setAddrForm(p => ({ ...p, address_type: e.target.value }))}>



                        <option value="delivery">Delivery</option>



                        <option value="branch">Branch</option>



                        <option value="warehouse">Warehouse</option>



                        <option value="registered">Registered</option>



                        <option value="billing">Billing</option>



                        <option value="shipping">Shipping</option>



                        <option value="other">Other</option>



                      </select>



                    </div>



                  </div>



                  <div className="form-group" style={{ marginBottom: 10 }}>



                    <label className="form-label" style={{ fontSize: '0.78rem' }}>Address</label>



                    <textarea className="form-control" rows={2} style={{ fontSize: '0.83rem' }} value={addrForm.address} onChange={e => setAddrForm(p => ({ ...p, address: e.target.value }))} />



                  </div>



                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8, marginBottom: 10 }}>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>City</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} value={addrForm.city} onChange={e => setAddrForm(p => ({ ...p, city: e.target.value }))} />



                    </div>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>State</label>



                      {addrForm.country === 'India' || !addrForm.country



                        ? <select className="form-control" style={{ fontSize: '0.83rem' }} value={addrForm.state} onChange={e => setAddrForm(p => ({ ...p, state: e.target.value }))}>



                          <option value="">— Select —</option>



                          {INDIAN_STATES.map(s => <option key={s.code} value={s.name}>{s.name}</option>)}



                        </select>



                        : <input className="form-control" style={{ fontSize: '0.83rem' }} value={addrForm.state} onChange={e => setAddrForm(p => ({ ...p, state: e.target.value }))} />



                      }



                    </div>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>ZIP</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} value={addrForm.zip_code} onChange={e => setAddrForm(p => ({ ...p, zip_code: e.target.value }))} />



                    </div>



                    <div className="form-group" style={{ marginBottom: 0 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Country</label>



                      <select className="form-control" style={{ fontSize: '0.83rem' }} value={addrForm.country} onChange={e => setAddrForm(p => ({ ...p, country: e.target.value, state: e.target.value !== 'India' ? '' : p.state }))}>



                        <option value="">— Select —</option>



                        {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}



                      </select>



                    </div>



                  </div>



                  <div style={{ display: 'flex', gap: 8 }}>



                    <button className="btn btn-primary btn-sm" onClick={handleAddrSave} disabled={addrSaving || !addrForm.label.trim()}>{addrSaving ? 'Saving…' : addrEditId ? 'Update' : 'Add'}</button>



                    <button className="btn btn-secondary btn-sm" onClick={() => { setAddrFormOpen(false); setAddrEditId(null); }}>Cancel</button>



                  </div>



                </div>



              )}



              {extraAddresses.length === 0 && !addrFormOpen ? (



                <div style={{ color: 'var(--text-muted)', fontSize: '0.83rem' }}>No additional addresses added.</div>



              ) : (



                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



                  {extraAddresses.map(addr => (



                    <div key={addr.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 12px', background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 8 }}>



                      <div style={{ flex: 1, minWidth: 0 }}>



                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>



                          <span style={{ fontWeight: 600, fontSize: '0.85rem' }}>{addr.label}</span>



                          <span style={{ fontSize: '0.7rem', padding: '1px 7px', borderRadius: 8, background: 'var(--primary-lighter)', color: 'var(--primary)', fontWeight: 600, textTransform: 'capitalize' }}>{addr.address_type}</span>



                        </div>



                        <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>



                          {[addr.address, addr.city, addr.state, addr.zip_code, addr.country].filter(Boolean).join(', ') || '—'}



                        </div>



                      </div>



                      {canWrite && (



                        <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>



                          <button className="btn btn-ghost btn-icon btn-sm" title="Edit" onClick={() => startAddrEdit(addr)}>



                            <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>



                          </button>



                          <button className="btn btn-ghost btn-icon btn-sm" title="Delete" style={{ color: 'var(--error)' }} onClick={() => handleAddrDelete(addr.id)}>



                            <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6M9 6V4h6v2" /></svg>



                          </button>



                        </div>



                      )}



                    </div>



                  ))}



                </div>



              )}



            </div>







            {viewModal.client.notes && <div style={{ background: 'var(--surface-2)', padding: 12, borderRadius: 8, fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: 16 }}>{viewModal.client.notes}</div>}







            <div style={{ marginBottom: 10 }}>



              <div style={{ fontWeight: 600, fontSize: '0.875rem', marginBottom: 8 }}>Key Contacts ({viewModal.contacts.length})</div>



              {viewModal.contacts.length === 0 ? <div style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>No contacts added</div> : (



                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>



                  {viewModal.contacts.slice(0, 5).map(con => (



                    <div key={con.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--surface-2)', borderRadius: 8 }}>



                      <div>



                        <div style={{ fontWeight: 600, fontSize: '0.83rem' }}>{con.name}{con.is_primary ? ' ★' : ''}</div>



                        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>{con.designation || ''}{con.department ? ` · ${con.department.toUpperCase()}` : ''}</div>



                      </div>



                      <div style={{ textAlign: 'right', fontSize: '0.75rem', color: 'var(--text-muted)' }}>



                        {con.email && <div>{con.email}</div>}



                        {con.phone && <div>{con.phone}</div>}



                      </div>



                    </div>



                  ))}



                </div>



              )}



            </div>







            <div>



              <div style={{ fontWeight: 600, fontSize: '0.875rem', marginBottom: 8 }}>Recent Inquiries ({viewModal.inquiries.length})</div>



              {viewModal.inquiries.length === 0 ? <div style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>No inquiries yet</div> : (



                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>



                  {viewModal.inquiries.slice(0, 4).map(inq => (



                    <div key={inq.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', background: 'var(--surface-2)', borderRadius: 8 }}>



                      <div style={{ fontWeight: 600, fontSize: '0.82rem', color: 'var(--primary)' }}>{inq.inquiry_number}</div>



                      <span className={`badge badge-${inq.status === 'won' ? 'success' : inq.status === 'lost' ? 'danger' : 'warning'}`} style={{ textTransform: 'capitalize', fontSize: '0.7rem' }}>{inq.status}</span>



                    </div>



                  ))}



                </div>



              )}



            </div>







            {/* Documents */}



            <div style={{ marginTop: 20, borderTop: '1px solid var(--border)', paddingTop: 16 }}>



              <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 12 }}>Attached Documents</div>



              <div style={{ background: 'var(--surface-2)', borderRadius: 8, padding: 14, marginBottom: 12, border: '1px solid var(--border)' }}>



                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>



                  <div className="form-group" style={{ marginBottom: 0, minWidth: 140 }}>



                    <label className="form-label" style={{ fontSize: '0.78rem' }}>Document Type</label>



                    <select className="form-control form-select" style={{ fontSize: '0.83rem' }} value={docForm.doc_type}



                      onChange={e => setDocForm(p => ({ ...p, doc_type: e.target.value, doc_description: '' }))}>



                      <option value="nda">NDA</option>



                      <option value="business_reg">Business Registration</option>



                      <option value="gst_cert">GST Certificate</option>



                      <option value="drug_license">Drug License</option>



                      <option value="pan_card">PAN Card</option>



                      <option value="agreement">Agreement / Contract</option>



                      <option value="others">Others</option>



                    </select>



                  </div>



                  {docForm.doc_type === 'others' && (



                    <div className="form-group" style={{ marginBottom: 0, flex: 1, minWidth: 130 }}>



                      <label className="form-label" style={{ fontSize: '0.78rem' }}>Describe Type *</label>



                      <input className="form-control" style={{ fontSize: '0.83rem' }} placeholder="e.g. NDA, Agreement…"



                        value={docForm.doc_description} onChange={e => setDocForm(p => ({ ...p, doc_description: e.target.value }))} />



                    </div>



                  )}



                  <div className="form-group" style={{ marginBottom: 0, flex: 2, minWidth: 160 }}>



                    <label className="form-label" style={{ fontSize: '0.78rem' }}>File</label>



                    <input type="file" className="form-control" style={{ fontSize: '0.83rem' }}



                      accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.webp,.txt"



                      onChange={e => setDocForm(p => ({ ...p, file: e.target.files[0] || null }))} />



                  </div>



                  <button className="btn btn-primary btn-sm" onClick={handleDocUpload} disabled={docUploading} style={{ marginBottom: 2 }}>



                    {docUploading ? 'Uploading…' : 'Attach'}



                  </button>



                </div>



                {docError && <div style={{ marginTop: 8, color: 'var(--error)', fontSize: '0.8rem' }}>{docError}</div>}



              </div>



              {docs.length === 0 ? (



                <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem', padding: '8px 0' }}>No documents attached yet.</div>



              ) : (



                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



                  {docs.map(doc => (



                    <div key={doc.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 8 }}>



                      <div style={{ fontSize: '1.1rem' }}>{docTypeIcon(doc.original_name)}</div>



                      <div style={{ flex: 1, minWidth: 0 }}>



                        <div style={{ fontWeight: 600, fontSize: '0.83rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{doc.original_name}</div>



                        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>



                          <span style={{ fontWeight: 600, color: 'var(--primary)' }}>



                            {doc.doc_type === 'others' && doc.doc_description ? doc.doc_description : docTypeLabel(doc.doc_type)}



                          </span>



                          {' · '}{doc.uploaded_by_name}



                          {' · '}{new Date(doc.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}



                        </div>



                      </div>



                      <button className="btn btn-ghost btn-icon btn-sm" onClick={() => handleDocDownload(doc.id, doc.original_name)}>



                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" /></svg>



                      </button>



                      <button className="btn btn-ghost btn-icon btn-sm" style={{ color: 'var(--error)' }} onClick={() => handleDocDelete(doc.id)}>



                        <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6M9 6V4h6v2" /></svg>



                      </button>



                    </div>



                  ))}



                </div>



              )}



            </div>







            {/* Customer Portal */}



            {canWrite && viewModal.open && viewModal.client && (



              <div style={{ marginTop: 16, padding: '12px 14px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 }}>



                <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#475569', marginBottom: 8 }}>🔗 Customer Portal</div>



                {viewModal.client.portal_enabled ? (



                  <div>



                    <div style={{ fontSize: '0.78rem', color: '#64748b', marginBottom: 8 }}>



                      Portal is active.



                      {viewModal.client.portal_last_access && ` Last accessed: ${new Date(viewModal.client.portal_last_access).toLocaleString('en-IN')}`}



                    </div>



                    <div style={{ display: 'flex', gap: 8 }}>



                      <button className="btn btn-sm" onClick={() => handleRegeneratePortal(viewModal.client.id)} style={{ fontSize: '0.78rem' }}>



                        Regenerate Link



                      </button>



                      <button className="btn btn-sm" onClick={() => handleDisablePortal(viewModal.client.id)} style={{ fontSize: '0.78rem', color: '#dc2626' }}>



                        Disable



                      </button>



                    </div>



                  </div>



                ) : (



                  <div>



                    <div style={{ fontSize: '0.78rem', color: '#94a3b8', marginBottom: 8 }}>No portal access. Generate a link to share with this client.</div>



                    <button className="btn btn-sm btn-primary" onClick={() => handleGeneratePortal(viewModal.client.id)} style={{ fontSize: '0.78rem' }}>



                      Generate Portal Link



                    </button>



                  </div>



                )}



                {portalLink && portalLinkClientId === viewModal.client.id && (



                  <div style={{ marginTop: 8, padding: '8px 10px', background: '#dbeafe', border: '1px solid #93c5fd', borderRadius: 6, fontSize: '0.75rem', display: 'flex', alignItems: 'center', gap: 8 }}>



                    <span style={{ flex: 1, wordBreak: 'break-all', color: '#1e40af' }}>{portalLink}</span>



                    <button onClick={() => { navigator.clipboard.writeText(portalLink); }} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1d4ed8', fontWeight: 700, fontSize: '0.75rem', flexShrink: 0 }}>Copy</button>



                  </div>



                )}



              </div>



            )}







            {/* Send Email */}



            {canWrite && viewModal.open && viewModal.client && (



              <div style={{ marginTop: 16, padding: '12px 14px', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8 }}>



                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>



                  <div style={{ fontWeight: 600, fontSize: '0.82rem', color: '#475569' }}>✉ Send Email</div>



                  {!emailState.open && !emailState.sent && (



                    <button className="btn btn-sm btn-primary" style={{ fontSize: '0.78rem' }}



                      onClick={async () => {



                        if (!emailState.templates.length) {



                          try {



                            const { data } = await api.get('/email-templates');



                            setEmailState(s => ({ ...s, open: true, templates: data.data || [], to_email: viewModal.client.email || '', to_name: viewModal.client.name || '', sent: false, error: '', selectedId: '' }));



                          } catch { setEmailState(s => ({ ...s, open: true, templates: [], to_email: viewModal.client.email || '', sent: false, error: '' })); }



                        } else {



                          setEmailState(s => ({ ...s, open: true, to_email: viewModal.client.email || '', to_name: viewModal.client.name || '', sent: false, error: '' }));



                        }



                      }}>



                      Send Email



                    </button>



                  )}



                </div>



                {emailState.sent && (



                  <div style={{ marginTop: 8, fontSize: '0.78rem', color: '#10b981', fontWeight: 600 }}>



                    Email sent successfully!{' '}



                    <button onClick={() => setEmailState(s => ({ ...s, open: false, sent: false, selectedId: '' }))} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#0369a1', fontSize: '0.78rem', padding: 0, textDecoration: 'underline' }}>Send another</button>



                  </div>



                )}



                {emailState.open && !emailState.sent && (



                  <div style={{ marginTop: 10, display: 'flex', flexDirection: 'column', gap: 8 }}>



                    <select className="form-control" style={{ fontSize: '0.8rem' }} value={emailState.selectedId} onChange={e => setEmailState(s => ({ ...s, selectedId: e.target.value }))}>



                      <option value="">— Select a template —</option>



                      {emailState.templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}



                    </select>



                    <input className="form-control" style={{ fontSize: '0.8rem' }} type="email" placeholder="Recipient email" value={emailState.to_email} onChange={e => setEmailState(s => ({ ...s, to_email: e.target.value, error: '' }))} />



                    {emailState.error && <div style={{ fontSize: '0.75rem', color: '#dc2626' }}>{emailState.error}</div>}



                    <div style={{ display: 'flex', gap: 8 }}>



                      <button className="btn btn-sm btn-primary" style={{ fontSize: '0.78rem' }} disabled={emailState.sending || !emailState.selectedId || !emailState.to_email.trim()}



                        onClick={async () => {



                          setEmailState(s => ({ ...s, sending: true, error: '' }));



                          try {



                            await api.post('/email-templates/send', {



                              template_id: emailState.selectedId,



                              to_email: emailState.to_email.trim(),



                              to_name: emailState.to_name,



                              variables: { client_name: viewModal.client.name },



                              client_id: viewModal.client.id,



                            });



                            setEmailState(s => ({ ...s, sending: false, sent: true, open: false }));



                          } catch (err) {



                            setEmailState(s => ({ ...s, sending: false, error: err.response?.data?.message || 'Send failed' }));



                          }



                        }}>



                        {emailState.sending ? 'Sending…' : 'Send'}



                      </button>



                      <button className="btn btn-sm btn-secondary" style={{ fontSize: '0.78rem' }} onClick={() => setEmailState(s => ({ ...s, open: false }))}>Cancel</button>



                    </div>



                  </div>



                )}



              </div>



            )}



            {/* ── Access Control (admin / manager only) ── */}

            {(isAdmin || isManager) && (

              <div style={{ marginTop: 20, borderTop: '1px solid var(--border)', paddingTop: 16 }}>

                <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 12 }}>Access Control</div>

                <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginBottom: 10 }}>
                  The BD owner always has access. Add additional users below.
                </div>

                {/* Existing permissions */}
                {clientPerms.length > 0 && (
                  <div style={{ marginBottom: 12 }}>
                    {clientPerms.map(p => (
                      <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 10px', background: 'var(--surface-2)', borderRadius: 7, border: '1px solid var(--border)', marginBottom: 6 }}>
                        <div style={{ flex: 1 }}>
                          <span style={{ fontWeight: 600, fontSize: '0.83rem' }}>{p.user_name}</span>
                          <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginLeft: 6 }}>{p.user_role}</span>
                        </div>
                        <select
                          value={p.access_level}
                          onChange={async e => {
                            await api.put(`/clients/${viewModal.client.id}/permissions/${p.id}`, { access_level: e.target.value });
                            loadPerms(viewModal.client.id);
                          }}
                          style={{ fontSize: '0.78rem', padding: '3px 6px', borderRadius: 5, border: '1px solid var(--border)' }}
                        >
                          <option value="read_only">Read Only</option>
                          <option value="read_write">Read & Write</option>
                        </select>
                        <button
                          onClick={async () => {
                            await api.delete(`/clients/${viewModal.client.id}/permissions/${p.id}`);
                            loadPerms(viewModal.client.id);
                          }}
                          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--error)', fontSize: '0.8rem', padding: '2px 6px' }}
                          title="Remove access"
                        >✕</button>
                      </div>
                    ))}
                  </div>
                )}

                {/* Add permission form */}
                {permError && <div style={{ fontSize: '0.8rem', color: '#dc2626', marginBottom: 8, padding: '6px 10px', background: '#fef2f2', borderRadius: 6 }}>{permError}</div>}
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <label style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-secondary)' }}>User</label>
                    <select
                      value={permForm.user_id}
                      onChange={e => setPermForm(p => ({ ...p, user_id: e.target.value }))}
                      style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem', minWidth: 160 }}
                    >
                      <option value="">Select user…</option>
                      {users
                        .filter(u => u.id !== viewModal.client?.assigned_to && !clientPerms.some(p => p.user_id === u.id))
                        .map(u => (
                          <option key={u.id} value={u.id}>{u.name} ({u.role})</option>
                        ))}
                    </select>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <label style={{ fontSize: '0.72rem', fontWeight: 600, color: 'var(--text-secondary)' }}>Access Level</label>
                    <select
                      value={permForm.access_level}
                      onChange={e => setPermForm(p => ({ ...p, access_level: e.target.value }))}
                      style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid var(--border)', fontSize: '0.82rem' }}
                    >
                      <option value="read_only">Read Only</option>
                      <option value="read_write">Read & Write</option>
                    </select>
                  </div>
                  <button
                    disabled={!permForm.user_id || permSaving}
                    onClick={async () => {
                      if (!permForm.user_id) return;
                      setPermSaving(true); setPermError('');
                      try {
                        await api.post(`/clients/${viewModal.client.id}/permissions`, { user_id: permForm.user_id, access_level: permForm.access_level });
                        setPermForm({ user_id: '', access_level: 'read_only', notes: '' });
                        loadPerms(viewModal.client.id);
                      } catch (err) {
                        setPermError(err.response?.data?.message || 'Failed to add permission.');
                      } finally { setPermSaving(false); }
                    }}
                    style={{ padding: '7px 14px', borderRadius: 7, border: 'none', background: 'var(--primary)', color: '#fff', fontWeight: 600, fontSize: '0.82rem', cursor: (!permForm.user_id || permSaving) ? 'not-allowed' : 'pointer', opacity: (!permForm.user_id || permSaving) ? 0.6 : 1 }}
                  >
                    {permSaving ? 'Adding…' : 'Grant Access'}
                  </button>
                </div>

              </div>

            )}



          </>



        )}



      </Modal>







      {/* Addresses Modal */}



      <Modal



        open={addrModal.open}



        onClose={() => { setAddrModal({ open: false, entityId: null, entityName: '' }); setAddrFormOpen(false); setAddrEditId(null); }}



        title={`Addresses — ${addrModal.entityName}`}



        size="md"



        footer={<button className="btn btn-secondary" onClick={() => { setAddrModal({ open: false, entityId: null, entityName: '' }); setAddrFormOpen(false); setAddrEditId(null); }}>Close</button>}



      >



        <div>



          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>



            <div style={{ fontSize: '0.83rem', color: 'var(--text-muted)' }}>{extraAddresses.length} address{extraAddresses.length !== 1 ? 'es' : ''} saved</div>



            {!addrFormOpen && (



              <button className="btn btn-primary btn-sm" onClick={() => { setAddrEditId(null); setAddrForm({ label: '', address_type: 'other', address: '', city: '', state: '', zip_code: '', country: 'India' }); setAddrFormOpen(true); }}>



                + Add Address



              </button>



            )}



          </div>



          {addrFormOpen && (



            <div style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 8, padding: 14, marginBottom: 14 }}>



              <div style={{ fontWeight: 600, fontSize: '0.85rem', marginBottom: 10 }}>{addrEditId ? 'Edit Address' : 'New Address'}</div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">Label *</label>



                  <input className="form-control" placeholder="e.g. Head Office, Warehouse" value={addrForm.label} onChange={e => setAddrForm(p => ({ ...p, label: e.target.value }))} />



                </div>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">Type</label>



                  <select className="form-control form-select" value={addrForm.address_type} onChange={e => setAddrForm(p => ({ ...p, address_type: e.target.value }))}>



                    <option value="delivery">Delivery</option>



                    <option value="branch">Branch</option>



                    <option value="warehouse">Warehouse</option>



                    <option value="registered">Registered</option>



                    <option value="billing">Billing</option>



                    <option value="shipping">Shipping</option>



                    <option value="other">Other</option>



                  </select>



                </div>



              </div>



              <div className="form-group" style={{ marginBottom: 10 }}>



                <label className="form-label">Street Address</label>



                <textarea className="form-control" rows={2} value={addrForm.address} onChange={e => setAddrForm(p => ({ ...p, address: e.target.value }))} />



              </div>



              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: 8, marginBottom: 12 }}>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">City</label>



                  <input className="form-control" value={addrForm.city} onChange={e => setAddrForm(p => ({ ...p, city: e.target.value }))} />



                </div>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">State</label>



                  {addrForm.country === 'India' || !addrForm.country



                    ? <select className="form-control" value={addrForm.state} onChange={e => setAddrForm(p => ({ ...p, state: e.target.value }))}>



                      <option value="">— Select —</option>



                      {INDIAN_STATES.map(s => <option key={s.code} value={s.name}>{s.name}</option>)}



                    </select>



                    : <input className="form-control" value={addrForm.state} onChange={e => setAddrForm(p => ({ ...p, state: e.target.value }))} />



                  }



                </div>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">ZIP</label>



                  <input className="form-control" value={addrForm.zip_code} onChange={e => setAddrForm(p => ({ ...p, zip_code: e.target.value }))} />



                </div>



                <div className="form-group" style={{ marginBottom: 0 }}>



                  <label className="form-label">Country</label>



                  <select className="form-control" value={addrForm.country} onChange={e => setAddrForm(p => ({ ...p, country: e.target.value, state: e.target.value !== 'India' ? '' : p.state }))}>



                    <option value="">— Select —</option>



                    {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}



                  </select>



                </div>



              </div>



              <div style={{ display: 'flex', gap: 8 }}>



                <button className="btn btn-primary btn-sm" onClick={handleAddrSave} disabled={addrSaving || !addrForm.label.trim()}>{addrSaving ? 'Saving…' : addrEditId ? 'Update' : 'Add'}</button>



                <button className="btn btn-secondary btn-sm" onClick={() => { setAddrFormOpen(false); setAddrEditId(null); }}>Cancel</button>



              </div>



            </div>



          )}



          {extraAddresses.length === 0 && !addrFormOpen ? (



            <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.85rem', padding: '24px 0' }}>No additional addresses yet. Click <strong>+ Add Address</strong> to add one.</div>



          ) : (



            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>



              {extraAddresses.map(addr => (



                <div key={addr.id} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, padding: '12px 14px', background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 8 }}>



                  <div style={{ flex: 1, minWidth: 0 }}>



                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>



                      <span style={{ fontWeight: 600, fontSize: '0.87rem' }}>{addr.label}</span>



                      <span style={{ fontSize: '0.7rem', padding: '1px 8px', borderRadius: 8, background: 'var(--primary-lighter)', color: 'var(--primary)', fontWeight: 600, textTransform: 'capitalize' }}>{addr.address_type}</span>



                    </div>



                    <div style={{ fontSize: '0.82rem', color: 'var(--text-secondary)' }}>



                      {[addr.address, addr.city, addr.state, addr.zip_code, addr.country].filter(Boolean).join(', ') || '—'}



                    </div>



                  </div>



                  <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>



                    <button className="btn btn-ghost btn-icon btn-sm" title="Edit" onClick={() => startAddrEdit(addr)}>



                      <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>



                    </button>



                    <button className="btn btn-ghost btn-icon btn-sm" title="Delete" style={{ color: 'var(--error)' }} onClick={() => handleAddrDelete(addr.id)}>



                      <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6M14 11v6M9 6V4h6v2" /></svg>



                    </button>



                  </div>



                </div>



              ))}



            </div>



          )}



        </div>



      </Modal>







      {/* Freeze Confirm */}



      <Modal open={!!deleteConfirm} onClose={() => setDeleteConfirm(null)} title="Freeze Client"



        footer={<><button className="btn btn-secondary" onClick={() => setDeleteConfirm(null)}>Cancel</button><button className="btn btn-danger" onClick={handleDelete}>Freeze</button></>}



      >



        <p>Freeze <strong>{deleteConfirm?.name}</strong>? This will prevent any further edits. It can be unfrozen later.</p>



      </Modal>







      {/* Bulk Upload - Commented out for both user & admin */}


      {/*
      <BulkUpload

        open={bulkOpen}

        onClose={() => setBulkOpen(false)}

        onSuccess={load}

        title="Bulk Upload Clients"

        uploadUrl="/clients/bulk"

        templateUrl="/clients/template"

        columns={[
          { key: 'name', label: 'Company Name', required: true },
          { key: 'trading_name', label: 'Trading Name' },
          { key: 'type', label: 'Type', required: true },
          { key: 'email', label: 'Email' },
          { key: 'phone', label: 'Phone' },
          { key: 'contact_person', label: 'Contact Person' },
          { key: 'company_id_type', label: 'Company ID Type (GSTN/TIN/GST/HST/OTHERS)' },
          { key: 'company_id_value', label: 'Company ID Value' },
          { key: 'website', label: 'Website' },
          { key: 'address', label: 'Primary Address' },
          { key: 'city', label: 'City (Primary)' },
          { key: 'state', label: 'State (Primary)' },
          { key: 'zip_code', label: 'ZIP / Postal Code' },
          { key: 'country', label: 'Country (Primary)' },
          { key: 'potential', label: 'Potential' },
          { key: 'therapeutic_areas', label: 'Therapeutic Areas' },
          { key: 'regulatory_markets', label: 'Regulatory Markets' },
          { key: 'is_partner', label: 'Is Partner (1/0)' },
          { key: 'assigned_to_email', label: 'BD Owner (Email)' },
          { key: 'notes', label: 'Notes' },
          { key: 'billing_same_as_primary', label: 'Billing Same as Primary (1/0)' },
          { key: 'billing_address', label: 'Billing Address' },
          { key: 'billing_city', label: 'Billing City' },
          { key: 'billing_state', label: 'Billing State' },
          { key: 'billing_zip_code', label: 'Billing ZIP' },
          { key: 'billing_country', label: 'Billing Country' },
          { key: 'shipping_same_as_primary', label: 'Shipping Same as Primary (1/0)' },
          { key: 'shipping_address', label: 'Shipping Address' },
          { key: 'shipping_city', label: 'Shipping City' },
          { key: 'shipping_state', label: 'Shipping State' },
          { key: 'shipping_zip_code', label: 'Shipping ZIP' },
          { key: 'shipping_country', label: 'Shipping Country' },
          { key: 'license_number', label: 'License Number' },
          { key: 'license_expiry_date', label: 'License Expiry Date' },
          { key: 'credit_limit', label: 'Credit Limit' },
        ]}
      />
      */}


    </div>



  );



}



